// extracted by mini-css-extract-plugin
export default {"background":"propswrapper_background__cY3pH"};